import axiosClient from 'utils/axiosClient';
import { SubGenre } from '../../models/SubGenre';

export interface SubGenreResponse {
  status: string;
  message: string;
  data: SubGenre;
}

const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const service = {
  getSubGenre(id: string): Promise<SubGenreResponse> {
    const url = `sub-genre/${id}`;
    return axiosClient.get(url);
  },
  updateSubGenre(body: SubGenre, id: string): Promise<SubGenreResponse> {
    const url = `sub-genre/${id}`;
    return axiosClient.put(url, body, config);
  },
};

export default service;
